"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MakeSubmissionPage;
exports.SubmissionOverviewTab = exports.CampaignSubmissionGroup = exports.HeaderInfoBar = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _contentGroup = babelHelpers.interopRequireDefault(require("block/contentGroup"));

var _Overview = babelHelpers.interopRequireWildcard(require("tab/Overview"));

var _SubmissionInfo = babelHelpers.interopRequireDefault(require("sundance/SubmissionInfo"));

var _class3, _descriptor2, _temp2, _class5, _descriptor3, _descriptor4, _descriptor5, _temp3, _class7, _descriptor6, _temp4, _class9, _descriptor7, _temp5;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function MakeSubmissionPage(pageId, parentPageId) {
  var _class, _descriptor, _temp;

  var R = {};

  var parent = require(parentPageId);

  R.Page =
  /*#__PURE__*/
  function (_parent$default) {
    babelHelpers.inherits(SubmissionPage, _parent$default);

    function SubmissionPage() {
      babelHelpers.classCallCheck(this, SubmissionPage);
      return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(SubmissionPage).apply(this, arguments));
    }

    babelHelpers.createClass(SubmissionPage, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(R.Body, this.props.content);
      }
    }]);
    return SubmissionPage;
  }(parent.default);

  R.Body = (_class = (_temp =
  /*#__PURE__*/
  function (_parent$Body) {
    babelHelpers.inherits(SubmissionPageBody, _parent$Body);

    function SubmissionPageBody() {
      var _babelHelpers$getProt;

      var _this;

      babelHelpers.classCallCheck(this, SubmissionPageBody);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(SubmissionPageBody)).call.apply(_babelHelpers$getProt, [this].concat(args)));
      babelHelpers.initializerDefineProperty(_this, "campaignSubmissionGroup", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
      return _this;
    }

    babelHelpers.createClass(SubmissionPageBody, [{
      key: "renderAdditionalContentStack",
      value: function renderAdditionalContentStack() {
        var x = babelHelpers.get(babelHelpers.getPrototypeOf(SubmissionPageBody.prototype), "renderAdditionalContentStack", this).call(this);
        var r = x;

        if (this.campaignSubmissionGroup) {
          r = [_react.default.createElement(CampaignSubmissionGroup, _extends({}, this.campaignSubmissionGroup, {
            key: "submissions"
          }))];
          if (Array.isArray(x)) r = r.concat(x);else r.push(_react.default.createElement(x.type, Object.assign({
            "key": "footer"
          }, x.props)));
        }

        return r;
      }
    }]);
    return SubmissionPageBody;
  }(parent.Body), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "campaignSubmissionGroup", [_decorators.prop], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  return R;
}

var HeaderInfoBar = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(HeaderInfoBar, _Component);

  function HeaderInfoBar() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, HeaderInfoBar);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(HeaderInfoBar)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "info", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(HeaderInfoBar, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "submission-info-bar"
      }, _react.default.createElement("div", {
        "data-submission-bar": "true"
      }, _react.default.createElement(_SubmissionInfo.default, this.info)));
    }
  }]);
  return HeaderInfoBar;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "info", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.HeaderInfoBar = HeaderInfoBar;
var CampaignSubmissionGroup = (_class5 = (_temp3 =
/*#__PURE__*/
function (_ContentGroupBlock) {
  babelHelpers.inherits(CampaignSubmissionGroup, _ContentGroupBlock);

  function CampaignSubmissionGroup() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, CampaignSubmissionGroup);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(CampaignSubmissionGroup)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "customHeader", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "campaignLink", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "campaignTitle", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(CampaignSubmissionGroup, [{
    key: "renderCustomHeader",
    value: function renderCustomHeader(unused) {
      return _react.default.createElement("div", {
        className: "container submissions-group-title-container"
      }, _react.default.createElement("h1", null, "Recent Submissions for ", this.campaignTitle), _react.default.createElement("a", {
        className: "link-btn",
        href: this.campaignLink
      }, "View all submissions"));
    }
  }]);
  return CampaignSubmissionGroup;
}(_contentGroup.default), _temp3), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "customHeader", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "campaignLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "campaignTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
exports.CampaignSubmissionGroup = CampaignSubmissionGroup;
var SubmissionOverviewTab = (_class7 = (_temp4 =
/*#__PURE__*/
function (_OverviewTab) {
  babelHelpers.inherits(SubmissionOverviewTab, _OverviewTab);

  function SubmissionOverviewTab() {
    var _babelHelpers$getProt4;

    var _this4;

    babelHelpers.classCallCheck(this, SubmissionOverviewTab);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(SubmissionOverviewTab)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "submissionInfoBar", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    return _this4;
  }

  babelHelpers.createClass(SubmissionOverviewTab, [{
    key: "renderDescriptionHeader",
    value: function renderDescriptionHeader() {
      return _react.default.createElement("h2", null, "About this submission");
    }
  }, {
    key: "renderDiscussion",
    value: function renderDiscussion() {
      if (this.discussion) {
        return _react.default.createElement(SubmissionOverviewDiscussion, _extends({}, this.discussion, {
          info: this.submissionInfoBar
        }));
      }
    }
  }]);
  return SubmissionOverviewTab;
}(_Overview.default), _temp4), (_descriptor6 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "submissionInfoBar", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class7);
exports.SubmissionOverviewTab = SubmissionOverviewTab;
var SubmissionOverviewDiscussion = (_class9 = (_temp5 =
/*#__PURE__*/
function (_OverviewDiscussionTa) {
  babelHelpers.inherits(SubmissionOverviewDiscussion, _OverviewDiscussionTa);

  function SubmissionOverviewDiscussion() {
    var _babelHelpers$getProt5;

    var _this5;

    babelHelpers.classCallCheck(this, SubmissionOverviewDiscussion);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(SubmissionOverviewDiscussion)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "info", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    return _this5;
  }

  babelHelpers.createClass(SubmissionOverviewDiscussion, [{
    key: "renderTop",
    value: function renderTop() {
      if (this.info) {
        return _react.default.createElement("div", {
          className: "inner-content"
        }, _react.default.createElement("div", {
          "data-submission-bar": "true"
        }, _react.default.createElement(_SubmissionInfo.default, this.info)));
      }

      return null;
    }
  }]);
  return SubmissionOverviewDiscussion;
}(_Overview.OverviewDiscussionTab), _temp5), (_descriptor7 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "info", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class9);